import { useSyncExternalStore } from 'react'
import { CollectionState } from '../..'

export function useCountRecords (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('countRecordsChanged', callback),
    () => state.countRecords
  )
}
